<template>
  <div class="user-detail-refund-order">
    <el-row :gutter="20" style="width:100%">
      <el-col :span="24" style="width:100%">
        <div class="text-right"></div>
      </el-col>
    </el-row>

    <div class="margin-top">
      <el-table :data="userDetailRefundOrderInfo.orders" border style="width: 100%">
        <el-table-column prop="cartId" :label="$t('userDetailRefundOrder.orderNo')" align="center">
        </el-table-column>
        <el-table-column prop="prodName" :label="$t('userDetailRefundOrder.productName')" align="center">
        </el-table-column>
        <el-table-column prop="specValue" :label="$t('userDetailRefundOrder.productSpec')" align="center">
        </el-table-column>
        <el-table-column prop="personName" :label="$t('userDetailRefundOrder.userName')" align="center">
        </el-table-column>
        <el-table-column prop="returnPayPrice" :label="$t('userDetailRefundOrder.refundAmount')" align="center">
        </el-table-column>
        <el-table-column prop="stateName" :label="$t('userDetailRefundOrder.orderStatus')" align="center">
        </el-table-column>
        <el-table-column prop="returnReason" :label="$t('userDetailRefundOrder.refundReason')" align="center">
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('userDetailRefundOrder.applyTime')" align="center">
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-row :gutter="20" class="margin-top">
        <el-col :span="16"></el-col>
        <el-col :span="8">
          <el-pagination @current-change="handleCurrentChange" :current-page="pagination.currentPage"
            :page-size="pagination.pageSize" layout="total, prev, pager, next" :total="pagination.total">
          </el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getRefundOrderList } from '@/api/user/userDetailRefundOrderApi'

export default {
  name: 'UserDetailRefundOrder',
  data() {
    return {
      userDetailRefundOrderInfo: {
        orders: [],
        personId: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
  },
  beforeDestroy() {
  },
  methods: {
    open(data) {
      this.userDetailRefundOrderInfo.personId = data.userId
      this.loadRefundOrderData()
    },
    loadRefundOrderData() {
      const params = {
        personId: this.userDetailRefundOrderInfo.personId,
        page: this.pagination.currentPage,
        row: this.pagination.pageSize
      }
      getRefundOrderList(params).then(res => {
        this.userDetailRefundOrderInfo.orders = res.data
        this.pagination.total = res.records
      }).catch(error => {
        console.error('请求失败:', error)
      })
    },
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage
      this.loadRefundOrderData()
    }
  }
}
</script>

<style scoped>
.user-detail-refund-order {
  padding: 20px;
}

.margin-top {
  margin-top: 20px;
}

.text-right {
  text-align: right;
}
</style>